<div class="operation-consult-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Consultas</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações Realizadas</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Consulta de Operações</h1>
  </div>

  <section class="consult-content" aria-label="Consulta de operações">
    <div class="consult-toolbar">
      <b3-toggle-button
        class="period-toggle"
        size="sm"
        [active]="activePeriodIndex"
        aria-label="Período da operação"
        (b3-change)="onPeriodToggleChange($event)">
        <b3-toggle-button-item
          *ngFor="let option of periodOptions; let i = index; trackBy: trackByPeriodLabel"
          [id]="'period-option-' + i">
          + {{ option.label }}
        </b3-toggle-button-item>
      </b3-toggle-button>

      <div class="consult-toolbar__action">
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          size="md"
          class="consult-toolbar__filter-btn"
          (b3-click)="openFilter()">
          <b3-icon name="filter_list"></b3-icon>
          Filtrar
        </b3-button>
      </div>
    </div>

    <app-operation-list-table
      (valueTotal)="onValueTotal($event)"
      (valueFilterTotal)="onValueFilterTotal($event)"
      (depositDetailRequested)="openDepositDetail($event)"
      (retirementDetailRequested)="openRetirementDetail($event)"
      (transferDetailRequested)="openTransferDetail($event)"
      (custodyWithdrawalDetailRequested)="openCustodyWithdrawalDetail($event)"
      (acxTradeDetailRequested)="openAcxTradeDetail($event)"
      (b3WithdrawalTransferDetailRequested)="openB3WithdrawalTransferDetail($event)">
    </app-operation-list-table>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-operation-list-filter
  [isOpen]="showFilter"
  (closed)="showFilter = false">
</app-operation-list-filter>

<app-operation-deposit-details-drawer
  [open]="isDepositDrawerOpen"
  [operation]="selectedDepositOperation"
  (openChange)="onDepositDrawerOpenChange($event)">
</app-operation-deposit-details-drawer>

<app-operation-retirement-details-drawer
  [open]="isRetirementDrawerOpen"
  [operation]="selectedRetirementOperation"
  (openChange)="onRetirementDrawerOpenChange($event)">
</app-operation-retirement-details-drawer>

<app-operation-transfer-details-drawer
  [open]="isTransferDrawerOpen"
  [operation]="selectedTransferOperation"
  (openChange)="onTransferDrawerOpenChange($event)">
</app-operation-transfer-details-drawer>

<app-operation-custody-withdrawal-details-drawer
  [open]="isCustodyWithdrawalDrawerOpen"
  [operation]="selectedCustodyWithdrawalOperation"
  (openChange)="onCustodyWithdrawalDrawerOpenChange($event)">
</app-operation-custody-withdrawal-details-drawer>

<app-operation-acx-trade-details-drawer
  [open]="isAcxTradeDrawerOpen"
  [operation]="selectedAcxTradeOperation"
  (openChange)="onAcxTradeDrawerOpenChange($event)">
</app-operation-acx-trade-details-drawer>

<app-operation-b3-withdrawal-transfer-details-drawer
  [open]="isB3WithdrawalTransferDrawerOpen"
  (openChange)="onB3WithdrawalTransferDrawerOpenChange($event)">
</app-operation-b3-withdrawal-transfer-details-drawer>
